'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import { showErrorToastWithAlgoPhoneNumber } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError'
import { Input } from '@algoacademy/design-system/web/forms/Input'
import { H3 } from '@algoacademy/design-system/web/marketing/typography/Heading'
import { P3 } from '@algoacademy/design-system/web/marketing/typography/Paragraph'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { useTRPC } from '@/app/_trpc/config'

type NewsletterForm = {
  email: string
}

export function FooterNewsletter() {
  const trpc = useTRPC()
  const subscribeNewsletterMutation = useMutation(
    trpc.notifications.subscribeNewsletter.mutationOptions()
  )
  const { register, handleSubmit, reset } = useForm<NewsletterForm>()

  const onSubmit = async (data: NewsletterForm) => {
    try {
      await subscribeNewsletterMutation.mutateAsync({ email: data.email })
      reset()
      toast.success('Udało się!', {
        description: 'Dziękujemy za zapisanie się do naszego newslettera!'
      })
    } catch {
      showErrorToastWithAlgoPhoneNumber()
    }
  }

  return (
    <div className='space-y-4'>
      <H3>Zapisz się do naszego newslettera</H3>
      <P3>Otrzymuj promocje i specjalne materiały.</P3>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className='flex flex-col items-center gap-4 lg:flex-row'
      >
        <label htmlFor='footer-newsletter-email' className='sr-only'>
          Adres e-mail
        </label>
        <Input
          id='footer-newsletter-email'
          placeholder='Email'
          type='email'
          {...register('email', { required: true })}
          className='h-full'
        />
        <Button marketing type='submit' className='text-nowrap lg:h-full lg:text-sm'>
          Zapisz się
        </Button>
      </form>
    </div>
  )
}
